export default "__VITE_ASSET__Gc0mtB0V__"